import LiveLayout from './components/LiveLayout';

/**
 * /live — the video wall.
 *
 * The <DemoData> banner that used to sit here ("picture, detections, latency and
 * direct-vs-relayed have no data source") is gone because it is no longer true:
 * the media path shipped on 2026-08-01 (relay on panda02 + hub /api/v1/whep) and
 * this page now plays it. What has no source is stated per tile instead, in the
 * only place where it can be honest — a stat the browser could not measure renders
 * as "—", and a tile that cannot get a picture says which hop failed.
 *
 * Still absent, and deliberately not drawn anywhere: detection boxes on the video.
 * The dog runs detection, but nothing publishes those boxes to the cloud, and
 * overlaying invented rectangles on a real picture would be the worst kind of lie
 * available on this page — it would look like the most credible part of it.
 */
export default function LivePage() {
  return (
    <div className="p-4 lg:p-6">
      <div className="mb-4 lg:mb-5 animate-fade-in-up">
        <h1 className="text-lg font-bold text-foreground-900 font-heading">视频墙</h1>
        <p className="text-xs text-foreground-500 mt-1">
          经 hub 中继观看:设备只上传一份, 与观看人数无关;没人看时不占设备上行
        </p>
      </div>
      <div className="animate-fade-in-up" style={{ animationDelay: '0.08s' }}>
        <LiveLayout />
      </div>
    </div>
  );
}
